import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';

import {
  getKpisForLandingZoneSuccess,
  getKpisForLandingZoneFailure,
  getCampaignsForLandingZoneSuccess,
  getCampaignsForLandingZoneFailure,
  getCampaignForLandingZoneSuccess,
  getCampaignForLandingZoneFailure,
} from './landing-zone-actions';

export function* doGetKpisForLandingZone(action) {
  try {
    const options = {
      endpoint: 'landingzone/kpis',
      options: {
        errorMessage: 'Could not fetch landing zone kpis',
        retryAction: action,
      },
    };
    const results = yield call(callApi, options);
    yield put(getKpisForLandingZoneSuccess(results));
  } catch (err) {
    yield put(getKpisForLandingZoneFailure(err));
  }
}

export function* doGetCampaignsForLandingZone(action) {
  const { plannerGroup, campaignId } = action.payload;
  try {
    const options = {
      // eslint-disable-next-line max-len
      endpoint: `campaigns/feed?plannerGroup=${plannerGroup}${campaignId ? `&campaignid=${campaignId}` : ''}`,
      options: {
        errorMessage: 'Could not fetch landing zone campaigns',
        retryAction: action,
      },
    };
    const results = yield call(callApi, options);
    if (campaignId) {
      yield put(getCampaignForLandingZoneSuccess(results));
    } else {
      yield put(getCampaignsForLandingZoneSuccess(results));
    }
  } catch (err) {
    if (campaignId) {
      yield put(getCampaignForLandingZoneFailure(err));
    } else {
      yield put(getCampaignsForLandingZoneFailure(err));
    }
  }
}

function* watchGetKpis() {
  yield takeLatest(actionTypes.KPI_LANDING_ZONE_REQUEST, doGetKpisForLandingZone);
}

function* watchGetCampaigns() {
  yield takeLatest(actionTypes.CAMPAIGNS_LANDING_ZONE_REQUEST, doGetCampaignsForLandingZone);
}

function* watchGetCampaign() {
  yield takeLatest(actionTypes.CAMPAIGN_LANDING_ZONE_REQUEST, doGetCampaignsForLandingZone);
}

export default [
  fork(watchGetKpis),
  fork(watchGetCampaigns),
  fork(watchGetCampaign),
];
